module.exports = __webpack_public_path__ + "img/innovacion.f1f3217b.svg";